import React, { Component, createRef } from "react";
import Banner from "../components/Banner";
import ClpTeacherBio from "../components/ClpTeacherBio";
import Footer from "../components/Footer";
import Header from "../components/Header";
import LatestBio from "../components/LatestBio";
import ShareDetails from "../components/ShareDetails";
import StoryCount from "../components/StoryCount";
import UpcommingBio from "../components/UpcommingBio";
import VideoModal from "../components/VideoModal";
import services from "../services";

class Home extends Component {
  constructor() {
    super();
    this.state = { isVideoModal: false, url: "", homePageDetails:{}, isLoader:true };
    this.myRef = createRef();
  }

  componentDidMount() {
    this.getTeacherBiographyDetails();
  }

  executeScroll = () => this.myRef.current.scrollIntoView();

  watchVideoNow = (url) => {
    this.setState({ url: url, isVideoModal: !this.state.isVideoModal });
  };

  getTeacherBiographyDetails = async () => {
    const homeDetails = await services.getApiCall("v2/course/tutorBio/home");
    this.setState({homePageDetails:homeDetails.data.data, isLoader:false});
  }

  render() {
    const { isVideoModal, url, homePageDetails } = this.state;
    console.log(homePageDetails);
    return (
      <div className="Home">
        <Header executeScroll={this.executeScroll} />
        <Banner
          isVideoModal={isVideoModal}
          watchVideoNow={this.watchVideoNow}
          bannerData={homePageDetails && homePageDetails.banner}
          isHome={true}
        />
        <div className="Home__Container">
          <LatestBio latestBioData={homePageDetails && homePageDetails.latest} />
          <UpcommingBio upcomingBioData={homePageDetails && homePageDetails.upcoming} />
          {/* <ClpTeacherBio title={"Media Coverage"} mediaCoverage={homePageDetails && homePageDetails.mediaCoverage} /> */}
          {/* <StoryCount /> */}
          <div ref={this.myRef}></div>
          <ShareDetails />
        </div>
        <Footer />
        {isVideoModal ? (
          <VideoModal closeModal={this.watchVideoNow} url={url} />
        ) : (
          ""
        )}
      </div>
    );
  }
}

export default Home;
